import React from "react";
import { Row, Col } from "reactstrap";

const Footer = (props) => {
  return (
    <Row className={props.psInfo ? "pr-0 pl-0 psInfo" : "pr-0 pl-0"}>
      <Col className="disclaimer">
        <Row>
          <Col>
            <h2 className="text-center padTop">Disclaimer</h2>

            <p className="text-center padTop">
              Disclaimer The United States District Court, District of Arizona
              cannot provide legal advice to the public. The United States
              District Court, District of Arizona, does not supervise or monitor
              the volunteer lawyers. Volunteer lawyers donate their time. The
              consultations serve as a guide for self-represented litigants. The
              consultations are only intended to assist individuals in gathering
              information about the civil litigation process. The consultations
              cannot replace individual lawyer representation. The consultations
              are not intended to, shall not be construed to, and may not be
              relied upon, to create or to limit any rights, substantive or
              procedural, enforceable at law, by any party in any matter, civil
              or criminal.
            </p>
          </Col>
        </Row>
        <Row>
          <Col
            style={{ background: "#00B4FF", width: "100%", minHeight: "50px" }}
          >
            <h2
              style={{
                color: "#FFFFFF",
                marginBottom: "0",
                fontSize: "1.3rem",
                paddingTop: "13px",
              }}
              className="text-center mt-10"
            >
              {/* Honorable G. Murray Snow, Chief Judge | Debra D. Lucas, Acting
              District Court Executive & Clerk of Court */}
              United States District Court District of Arizona | Federal Court
              Advice-Only Clinic
            </h2>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
export default Footer;
